import Contact from '../pages/Contact';
import Invoices from '../pages/Invoices';
import MyDetails from '../pages/MyDetails';
import ErrorPage from '../pages/ErrorPage';
import Overview from '../pages/Overview';
import Usage from '../pages/Usage';
import ChangePaymentDetails from '../pages/ChangePaymentDetails';
import LogIn from "../pages/LogIn";
import ChangeAdvancePayment from "../pages/ChangeAdvancePayment";
import LogOutCallback from "../pages/LogOutCallback";
import SubmitMeterReadings from "../pages/SubmitMeterReadings";
import LoggingOutPage from '../pages/LoggingOutPage';

const routes = {
  usage: {
    path: '/meterstanden',
    component: Usage,
    auth: 'private',
  },
  submitMeterReads: {
    path: '/meterstanden-doorgeven',
    component: SubmitMeterReadings,
  },
  invoices: {
    path: '/facturen',
    component: Invoices,
    auth: 'private',
  },
  myDetails: {
    path: '/mijn-gegevens',
    component: MyDetails,
    auth: 'private',
  },
  changePaymentDetails: {
    path: '/betaalgegevens-wijzigen',
    component: ChangePaymentDetails,
    auth: 'private',
  },
  changeAdvancePayment: {
    path: '/termijnbedrag-wijzigen',
    component: ChangeAdvancePayment,
    auth: 'private',
  },
  contact: {
    path: '/contact',
    component: Contact,
    auth: 'private',
  },
  overview: {
    path: '/',
    component: Overview,
    auth: 'private',
  },
  logIn: {
    path: '/login',
    component: LogIn,
    auth: 'public',
  },
  logOutCallback: {
    path: '/logout/callback',
    component: LogOutCallback,
  },
  LoggingOutPage: {
    path: '/log-out',
    component: LoggingOutPage,
  },
  notFound: {
    path: '*',
    component: ErrorPage,
  },
} as const;

export default routes;
